<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { directive as clickAway } from 'vue3-click-away';
import DesktopLocationsMenu from '@app/layout/nav/desktop/components/menus/DesktopLocationsMenu.vue';
import { useNavbarStore } from '@stores/layout/useNavbarStore';

defineOptions({ directives: { clickAway } });

const navbarStore = useNavbarStore();
const { closeTopPanel } = navbarStore;
const { isTopPanelOpen } = storeToRefs(navbarStore);

const onClickAway = (): void => {
  if (isTopPanelOpen.value) {
    closeTopPanel();
  }
};
</script>

<template>
  <div
    v-click-away="onClickAway"
    :class="[
      'top-navbar-desktop-panel',
      'rounded-b-lg border-0 border-t border-solid border-gray',
      'h-fit w-full',
      'px-8 py-6',
      'flex justify-center',
      'bg-white'
    ]"
  >
    <DesktopLocationsMenu />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables/colors' as *;

.top-navbar-desktop-panel {
  box-shadow: 0 -1px 0 0 $colorGray inset;
}
</style>
